"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Cells = undefined;

var _style = require("styled-jsx/style");

var _style2 = _interopRequireDefault(_style);

var _react = require("react");

var React = _interopRequireWildcard(_react);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = require('react-hot-loader').enterModule;

  enterModule && enterModule(module);
})();

var Cells = exports.Cells = function Cells(props) {
  return React.createElement(
    "div",
    {
      className: "jsx-2311117239" + " " + "cells"
    },
    React.createElement(_style2.default, {
      styleId: "2311117239",
      css: ".cells.jsx-2311117239>*{margin:20px;}.cells.jsx-2311117239{font-family:\"Source Sans Pro\",Helvetica Neue,Helvetica,Arial, sans-serif;font-size:16px;background-color:var(--theme-app-bg);color:var(--theme-app-fg);padding-bottom:10px;}"
    }),
    props.children
  );
};

Cells.defaultProps = {
  children: []
};
;

(function () {
  var reactHotLoader = require('react-hot-loader').default;

  var leaveModule = require('react-hot-loader').leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Cells, "Cells", "src/components/cells.js");
  leaveModule(module);
})();

;


//////////////////
// WEBPACK FOOTER
// ./~/@nteract/presentational-components/lib/components/cells.js
// module id = 207
// module chunks = 186292428941015